export default __webpack_public_path__ + "static/media/flag_us_uk.01060376.svg";